import { Segmentations } from '@/shared/types/home.types';
import { useEffect } from 'react';

interface AdsEventsProps {
  segmentacoes: Segmentations[];
}

export default function AdsEvents({ segmentacoes }: AdsEventsProps) {
  useEffect(() => {
    const { googletag } = window;
    googletag.cmd.push(() => {
      if (typeof segmentacoes !== 'undefined' && segmentacoes?.length > 0) {
        segmentacoes.forEach((seg: Segmentations) => {
          if (typeof seg?.valor === 'string') {
            googletag.pubads().setTargeting(seg.chave, seg?.valor);
          } else {
            seg?.valor?.forEach(subseg => {
              googletag.pubads().setTargeting(seg.chave, subseg);
            });
          }
        });
      }

      googletag.enableServices();
    }, []);
  }, [segmentacoes]);

  return null;
}
